import ApplicationSerializer from './application';

export default class SamlSerializer extends ApplicationSerializer {
  attrs = {
    company: {
      serialize: false,
    },
  };
}
